import { delay } from 'redux-saga';
import {
    all, call, put, takeEvery,
} from 'redux-saga/effects';

import { AlertAction, AlertKeys, removeAlert } from './actions';

function* removeNotification(action: AlertAction): IterableIterator<any> {
    if (!action.notRemove) {
        const delayTime = action.alert?.delay ?? 5000;
        yield call(delay, delayTime);
        yield put(removeAlert(action.alert));
    }
}
function* watchNotification(): IterableIterator<any> {
    yield takeEvery(AlertKeys.PUSH_ALERT, removeNotification);
}

export function* rootAlertSaga(): IterableIterator<any> {
    yield all(
        [
            watchNotification(),
        ],
    );
}
